import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';

// Favicon and touch icons from src/images (same as PHP header)
import faviconSvg from './images/veeyaa logo.svg';
import faviconPng from './images/veeyaa-full-logo.png';

(function injectFaviconLinks() {
  const head = document.head;
  const links = [
    { rel: 'icon', type: 'image/svg+xml', href: faviconSvg },
    { rel: 'apple-touch-icon', href: faviconPng },
    { rel: 'icon', type: 'image/png', sizes: '32x32', href: faviconPng },
    { rel: 'icon', type: 'image/png', sizes: '16x16', href: faviconPng },
  ];
  links.forEach((attrs) => {
    const link = document.createElement('link');
    Object.entries(attrs).forEach(([key, value]) => link.setAttribute(key, value));
    head.appendChild(link);
  });
})();

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
